import { Input, Modal } from "antd";

const SingleCardDetails = ({
  cardOpen,
  setCardOpen,
  handleOk,
  handleCancel,
  titleValue,
  gst,
  gstAmt,
  cGstRate,
  cGstAmt,
  sGstRate,
  sGstAmt,
  iGstRate,
  iGstAmt,
  basicAmt,
  netAmt,
  smCode,
}) => {
  return (
    <Modal
      className="sc-modal"
      title={<div className="sc-title">{titleValue}</div>}
      open={cardOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      closable={false}
      okText="OK"
      cancelText="Cancel"
    >
      {/* ---------- embedded styles (single file) ---------- */}
      <style>{`
        .sc-modal .ant-modal-content{padding:0;border-radius:18px;overflow:hidden}
        .sc-modal .ant-modal-header{margin:0;padding:0;background:transparent}
        .sc-modal .ant-modal-body{padding:14px;background:#eef1f8}
        .sc-modal .ant-modal-footer{margin:0;padding:4px 14px 14px;background:#eef1f8;display:flex;gap:10px}
        .sc-modal .ant-modal-footer .ant-btn{flex:1;height:42px;border-radius:12px;font-weight:800}
        .sc-modal .ant-modal-footer .ant-btn-primary{background:linear-gradient(135deg,#162566,#2a3c8f);border:0}

        .sc-title{background:linear-gradient(135deg,#1f8f6a,#52bd91);color:#fff;font-weight:800;font-size:17px;text-align:center;padding:14px 12px;letter-spacing:.6px}

        .sc-row{display:flex;align-items:center;justify-content:space-between;background:#fff;border:1.5px solid #e1e6f4;border-radius:14px;padding:10px 14px;box-shadow:0 1px 4px rgba(0,0,0,.05)}
        .sc-row + .sc-row, .sc-row + .sc-split, .sc-split + .sc-row{margin-top:8px}
        .sc-l{font-size:12px;font-weight:800;color:#6b76a8;text-transform:uppercase;letter-spacing:.4px}
        .sc-v{font-size:17px;font-weight:800;color:#162566}
        .sc-v.red{color:#e53935}

        .sc-split{display:grid;grid-template-columns:1fr 1fr;gap:8px}
        .sc-half{background:#fff;border:1.5px solid #e1e6f4;border-radius:14px;padding:8px 14px;box-shadow:0 1px 4px rgba(0,0,0,.05)}
        .sc-half .sc-v{font-size:16px;color:#e53935}

        .sc-net{margin-top:8px;display:flex;align-items:center;justify-content:space-between;background:linear-gradient(135deg,#162566,#2a3c8f);color:#fff;border-radius:14px;padding:12px 14px;box-shadow:0 4px 12px rgba(22,37,102,.3)}
        .sc-net .sc-l{color:#cfd7ff}
        .sc-net-v{font-size:22px;font-weight:800}
      `}</style>

      <div className="sc-row">
        <span className="sc-l">SMCODE</span>
        <span className="sc-v">{smCode || "-"}</span>
      </div>

      <div className="sc-row">
        <span className="sc-l">Basic.Amt</span>
        <span className="sc-v red">{basicAmt.toFixed(0) || 0.0}</span>
      </div>

      <div className="sc-row">
        <span className="sc-l">GST@{gst.toFixed(0) + "%" || 0.0 + "%"}</span>
        <span className="sc-v red">{gstAmt.toFixed(2) || 0.0}</span>
      </div>

      <div className="sc-split">
        <div className="sc-half">
          <div className="sc-l">
            CGST@{cGstRate.toFixed(0) + "%" || 0.0 + "%"}
          </div>
          <div className="sc-v">{cGstAmt.toFixed(2) || 0.0}</div>
        </div>
        <div className="sc-half">
          <div className="sc-l">
            SGST@{sGstRate.toFixed(0) + "%" || 0.0 + "%"}
          </div>
          <div className="sc-v">{sGstAmt.toFixed(2) || 0.0}</div>
        </div>
      </div>

      <div className="sc-net">
        <span className="sc-l">Net.Amt</span>
        <span className="sc-net-v">{netAmt.toFixed(0) || 0.0}</span>
      </div>
    </Modal>
  );
};

export default SingleCardDetails;